import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable({ providedIn: 'root' })
export class AppInitService {

  constructor(private auth: AuthService) {}

  init() {
    // return this.auth.refresh().catch(() => {});
  }
}